import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { isNullish } from '@blaze-shared/shared-util';
import { setValueByPath } from '@blaze-shared/workflow-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const notificationButtonV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate notificationButton element to v2',
  run: (props: PartialPropsOf<'notificationButton'>): void => {
    /* @typescript-eslint/no-deprecated */
    const label = props?.content?.notificationButton?.label;

    /**
     * Move label prop to appropriate section
     */
    if (!isNullish(label)) {
      setValueByPath(props, 'content.title.label', label);

      if (props?.content?.notificationButton?.label) {
        delete props.content.notificationButton.label;
      }
    }
  },
};
